module.exports = __webpack_public_path__ + "img/art-school-icon5.bf85edeb.png";